import { useMock, corporateGet, corporatePost, corporatePut, corporateDelete } from './client';
import courseGroupsMock from '@/mocks/corporate/courseGroups';

/**
 * Normaliza item de catálogo (curso ou grupo) vindo de /corporate/course-groups.
 */
export function normalizeCatalogItem(item = {}) {
    if (!item || typeof item !== 'object') return null;
    const id = item.id ?? item.courseId ?? item.groupId;
    if (id == null || id === '') return null;
    return {
        ...item,
        id,
        name: item.name || item.comercialName || item.commercialName || '',
        dayExpired: item.dayExpired ?? item.day_expired ?? item.deadlineDays ?? item.availabilityDeadline ?? null,
        status: item.status,
        type: item.type ?? item.courseType ?? null,
        mode: item.mode || null,
    };
}

function mapCatalogList(list) {
    if (!Array.isArray(list)) return [];
    return list.map(normalizeCatalogItem).filter(Boolean);
}

/**
 * Resposta Swagger GET /corporate/course-groups:
 * { content, totalElements, page, size, coursesAvailable, groupsAvailable }
 */
export function normalizeCourseGroupsListResponse(res = {}) {
    const content = mapCatalogList(res.content);
    const coursesAvailable = mapCatalogList(res.coursesAvailable);
    // groupsAvailable do schema; se vazio, usa content (lista de grupos type=2)
    const groupsFromField = mapCatalogList(res.groupsAvailable);
    const groupsAvailable = groupsFromField.length ? groupsFromField : content;

    return {
        ...res,
        content,
        coursesAvailable,
        groupsAvailable,
        totalElements: Number(res.totalElements ?? content.length) || 0,
        page: Number(res.page ?? 0) || 0,
        size: Number(res.size ?? content.length) || 0,
    };
}

export default {
    /**
     * GET /corporate/course-groups
     * Query: search, status, mode
     */
    async list(accessToken, params = {}) {
        if (useMock()) {
            const res = await courseGroupsMock.list(params);
            return normalizeCourseGroupsListResponse(res);
        }
        const query = {
            search: params.search || undefined,
            status: params.status || undefined,
            mode: params.mode || undefined,
            page: params.page != null ? params.page : undefined,
            size: params.size != null ? params.size : undefined,
        };
        const res = await corporateGet('/corporate/course-groups', accessToken, query);
        return normalizeCourseGroupsListResponse(res);
    },

    async getById(id, accessToken) {
        if (useMock()) return courseGroupsMock.getById(id);
        return corporateGet(`/corporate/course-groups/${id}`, accessToken);
    },

    async create(payload, accessToken) {
        if (useMock()) return courseGroupsMock.create(payload);
        return corporatePost('/corporate/course-groups', payload, accessToken);
    },

    async update(id, payload, accessToken) {
        if (useMock()) return courseGroupsMock.update(id, payload);
        return corporatePut(`/corporate/course-groups/${id}`, payload, accessToken);
    },

    async remove(id, accessToken) {
        if (useMock()) return courseGroupsMock.remove(id);
        return corporateDelete(`/corporate/course-groups/${id}`, accessToken);
    },

    /**
     * GET /portal/course-groups — catálogo de grupos/trilhas para o colaborador.
     * (Separado de /corporate/* para não exigir ROLE_ADMIN/MANAGER.)
     */
    async listForViewer(params = {}, accessToken) {
        if (useMock()) return courseGroupsMock.listForViewer(params);
        return corporateGet('/portal/course-groups', accessToken, params);
    },
};
